export default "__VITE_ASSET__CeTmxHXa__"